import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ROUTE_LABELS = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/schedule': 'Schedule',
  '/players': 'Players',
  '/player-assignments': 'Player Assignments',
  '/generator': 'Widget Generator',
  '/users': 'User Management',
  '/settings': 'Settings',
};

const buildBreadcrumbs = (pathname) => {
  const crumbs = [{ label: 'Home', to: '/dashboard' }];

  if (pathname === '/' || pathname === '/dashboard') return crumbs;

  const segments = pathname.split('/').filter(Boolean);
  let path = '';

  segments.forEach((segment, i) => {
    path += '/' + segment;
    const label = ROUTE_LABELS[path] || segment.charAt(0).toUpperCase() + segment.slice(1);
    crumbs.push({ label, to: path });
  });

  return crumbs;
};

const IconMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const Topbar = ({ onMenuClick }) => {
  const location = useLocation();
  const crumbs = buildBreadcrumbs(location.pathname);

  return (
    <header className="sticky top-0 z-30 flex items-center h-14 px-4 bg-white border-b border-slate-200 gap-4">
      {/* Mobile menu toggle */}
      <button
        onClick={onMenuClick}
        className="btn btn-ghost btn-sm btn-square lg:hidden"
        aria-label="Open menu"
      >
        <IconMenu />
      </button>

      {/* Breadcrumbs */}
      <div className="flex items-center gap-1.5 text-sm min-w-0">
        {crumbs.map((crumb, i) => (
          <React.Fragment key={crumb.to}>
            {i > 0 && (
              <svg className="w-4 h-4 text-slate-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            )}
            {i < crumbs.length - 1 ? (
              <Link
                to={crumb.to}
                className="text-slate-500 hover:text-slate-800 transition-colors truncate"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="font-semibold text-slate-800 truncate">{crumb.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </header>
  );
};

export default Topbar;
